import Mock from './Mock';

export default class CalendarServiceMock {
  static getCalendarSummary() {
    return Mock.call([
      {
        date: '2018-10-01T00:00:00',
        hasTime: true,
        hasUnsubmittedTime: false,
        calendarItems: [],
      },
      {
        date: '2018-10-02T00:00:00',
        hasTime: true,
        hasUnsubmittedTime: false,
        calendarItems: [
          {
            startDate: '2018-10-02T12:00:00',
            endDate: '2018-10-02T16:00:00',
            allDay: false,
            name: 'Événement du 2018-10-02',
            description: '',
            type: 'EVENT',
          },
        ],
      },
      {
        date: '2018-10-03T00:00:00',
        hasTime: false,
        hasUnsubmittedTime: true,
        calendarItems: [],
      },
      {
        date: '2018-10-08T00:00:00',
        hasTime: false,
        hasUnsubmittedTime: true,
        calendarItems: [
          {
            startDate: '2018-10-08T00:00:00',
            endDate: '2018-10-08T00:00:00',
            allDay: true,
            name: 'Action de Grâce',
            description: '',
            type: 'NON_WORKING_DAY.STATUTORY_HOLIDAY',
          },
        ],
      },
      {
        date: '2018-10-11T00:00:00',
        hasTime: false,
        hasUnsubmittedTime: false,
        calendarItems: [
          {
            startDate: '2018-10-11T08:00:00',
            endDate: '2018-10-11T16:00:00',
            allDay: false,
            name: 'Formation du 2018-10-11',
            description: '',
            type: 'TRAINING',
          },
          {
            startDate: '2018-10-11T08:00:00',
            endDate: '2018-10-11T12:00:00',
            allDay: false,
            name: 'Événement du 2018-10-11',
            description: '',
            type: 'EVENT',
          },
        ],
      },
      {
        date: '2018-10-16T00:00:00',
        hasTime: false,
        hasUnsubmittedTime: false,
        calendarItems: [
          {
            startDate: '2018-10-16T12:00:00',
            endDate: '2018-10-16T16:00:00',
            allDay: false,
            name: 'Formation du 2018-10-16',
            description: '',
            type: 'TRAINING',
          },
        ],
      },
      {
        date: '2018-10-21T00:00:00',
        hasTime: false,
        hasUnsubmittedTime: false,
        calendarItems: [
          {
            startDate: '2018-10-21T12:00:00',
            endDate: '2018-10-21T16:00:00',
            allDay: false,
            name: 'Formation du 2018-10-21',
            description: '',
            type: 'TRAINING',
          },
          {
            startDate: '2018-10-21T12:00:00',
            endDate: '2018-10-21T16:00:00',
            allDay: false,
            name: 'Événement du 2018-10-21',
            description: '',
            type: 'EVENT',
          },
        ],
      },
    ]);
  }
}
